module.exports = __webpack_public_path__ + "img/pocket-4_jp.ce16178.jpg";